export const moduleId = 'spaceCategories';
